import React from "react";
import { FilterCalendar, FilterTitle } from "./CalendarFilters.styled";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core";
import Skeleton from "@mui/material/Skeleton";

const GreenCheckbox = withStyles({
  root: {},
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CalendarFilters = ({ categories, categoriesFiltered }) => {
  return (
    <div style={{ height: "80vh" }}>
      <FilterTitle>Category</FilterTitle>
      <FilterCalendar>
        {categories.length === 0 &&
          [1, 2, 3, 4, 5].map((m) => {
            return (
              <div
                key={m}
                style={{ display: "inline-flex", marginBottom: "1em" }}
              >
                <Skeleton variant="rectangular" width={23} height={23} />
                <Skeleton
                  style={{ width: "8em", marginLeft: "9px" }}
                  animation="wave"
                />
              </div>
            );
          })}
        {categories.map((m, i) => {
          return (
            <FormControlLabel
              style={{ width: "100%", marginBottom: "0" }}
              key={i}
              control={
                <GreenCheckbox
                  style={{ color: m.codeColor }}
                  name="checkedG"
                  defaultChecked={true}
                  onChange={(e) => {
                    categoriesFiltered(m);
                  }}
                />
              }
              label={m.categoryName}
            />
          );
        })}
      </FilterCalendar>
    </div>
  );
};
export default CalendarFilters;
